export const mapToggleListWrapper = document.querySelector(
  ".js-map-list__wrapper"
);
export const mapToggleListButton = document.querySelector(
  ".js-map-list-toggle-button"
);

if (mapToggleListWrapper) {
  mapToggleListWrapper.addEventListener("transitionend", () => {
    mapToggleListWrapper.scrollTop = 0;
  });
}

export function filterPropertiesList(properties) {
  const mapToggleListAllProperties = document.querySelectorAll(
    ".map-property__wrapper"
  );

  if (!mapToggleListAllProperties) return;
  mapToggleListAllProperties.forEach((wrapper) => {
    wrapper.classList.add("hidden");
  });
  properties.forEach((property) => {
    const id_name = "map-property_id_" + property.properties.property_id;
    const wrapper = document.getElementById(id_name);
    wrapper.classList.remove("hidden");
  });
}
